<template><ListFilter field="suite_horizon" :options="opts" label="Свита / горизонт" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'SuiteHorizonFilter', components:{ListFilter}, data(){ return { opts:['ачимовская свита','бобриковский горизонт','доманиковый горизонт','мячковский горизонт','тюменская свита'] } } }
</script>
